var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 18,
    viewBox: "0 0 30 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4518 17.7473C17.213 17.7473 17.5243 17.2324 17.5155 16.5869C17.4768 14.1557 18.408 12.8469 20.0892 14.5527C21.9491 16.4397 22.3341 17.7473 24.5927 17.7473H28.5926C29.6025 17.7473 30 17.4175 30 16.9001C30 15.8056 28.2238 13.8742 26.7189 12.4563C24.6115 10.4716 24.5127 10.4246 26.3277 8.03535C28.5788 5.06902 31.5237 1.26821 28.9188 1.26821H23.9428C22.9778 1.26821 22.9078 1.81987 22.5641 2.64167C21.3204 5.61815 18.9567 9.47349 18.0592 8.88378C17.1205 8.2687 17.5505 5.83248 17.6218 2.21175C17.6405 1.25552 17.6355 0.599861 16.1956 0.259982C15.4094 0.0760922 14.6444 0 13.9344 0C11.0933 0 9.13337 1.2086 10.2471 1.41912C12.2107 1.79071 12.022 6.10133 11.5645 7.96306C10.7671 11.2046 7.76968 5.39621 6.52098 2.50344C6.21974 1.80846 6.12724 1.26821 5.05229 1.26821H0.983709C0.368735 1.26821 0 1.47112 0 1.9226C0 2.68606 3.69985 10.4449 7.2322 14.313C10.6771 18.0859 14.0819 17.7473 16.4518 17.7473Z",
    fill: "#F5F5F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.d08185d3d3e75c5b0f4a2885885cdc9c.svg";
export { ForwardRef as ReactComponent };